import { render, staticRenderFns } from "./FullscreenSelect.vue?vue&type=template&id=0a32f32f"
import script from "./FullscreenSelect.vue?vue&type=script&lang=ts"
export * from "./FullscreenSelect.vue?vue&type=script&lang=ts"
import style0 from "./FullscreenSelect.vue?vue&type=style&index=0&id=0a32f32f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseContainer: require('/builds/medtochka/medtochka-frontend/core/components/Base/BaseContainer.vue').default,BaseFullscreenDialog: require('/builds/medtochka/medtochka-frontend/core/components/Base/BaseFullscreenDialog.vue').default})
